export default "__VITE_ASSET__BN060Jp7__"